export const TERMS_TEXT = `
  <h2>Conditions générales d’utilisation</h2>
  <p class="legal-updated">Dernière mise à jour : 26/04/2026</p>

  <section class="legal-section">
    <h3>1. Objet du service</h3>
    <p>
      Saloons est une application mobile permettant aux utilisateurs de rejoindre des espaces
      virtuels associés à des lieux physiques, appelés “saloons”.
    </p>
    <p>
      L’application permet notamment de découvrir des lieux à proximité, de rejoindre un saloon
      lorsque l’utilisateur se trouve à proximité du lieu concerné, d’interagir avec d’autres
      utilisateurs et d’utiliser une messagerie temporaire.
    </p>
  </section>

  <section class="legal-section">
    <h3>2. Accès et inscription</h3>
    <p>L’accès à certaines fonctionnalités de l’application nécessite la création d’un compte.</p>
    <p>
      L’utilisateur s’engage à fournir des informations exactes, sincères et à jour. Il est
      responsable de la confidentialité de ses identifiants et de l’utilisation de son compte.
    </p>
    <p>L’application est réservée aux personnes âgées d’au moins 18 ans.</p>
  </section>

  <section class="legal-section">
    <h3>3. Fonctionnement des saloons</h3>
    <p>
      Les saloons sont associés à des lieux physiques tels que des bars, restaurants,
      établissements partenaires ou autres lieux référencés.
    </p>
    <p>
      L’accès à un saloon peut être conditionné à la position géographique de l’utilisateur.
      Certaines fonctionnalités peuvent donc nécessiter l’autorisation d’accès à la localisation
      du téléphone.
    </p>
    <p>
      L’accès à un saloon peut être limité dans le temps, notamment selon les règles définies par
      l’application.
    </p>
  </section>

  <section class="legal-section">
    <h3>4. Absence d’affiliation avec les lieux et événements référencés</h3>
    <p>
      Les lieux, établissements, événements ou activités visibles dans l’application Saloons
      peuvent être référencés à titre informatif afin de permettre aux utilisateurs de découvrir
      des espaces de rencontre ou d’interaction associés à des lieux physiques.
    </p>
    <p>
      Sauf mention expresse contraire dans l’application, Saloons n’est pas affiliée, partenaire,
      sponsorisée, approuvée ou exploitée par les lieux, établissements, organisateurs
      d’événements ou marques référencés.
    </p>
    <p>
      La présence d’un lieu ou d’un événement dans l’application ne constitue pas une
      recommandation officielle, un partenariat commercial, une validation par l’établissement
      concerné ou une garantie quant à l’exactitude, la disponibilité, la sécurité, les horaires,
      les tarifs ou les conditions d’accès du lieu ou de l’événement.
    </p>
    <p>
      Les utilisateurs sont invités à vérifier directement auprès du lieu, de l’établissement ou de
      l’organisateur concerné toute information utile avant de s’y rendre.
    </p>
    <p>
      Saloons se réserve le droit de modifier, retirer ou corriger à tout moment tout lieu,
      événement ou information référencé dans l’application.
    </p>
  </section>

  <section class="legal-section">
    <h3>5. Interactions et messagerie</h3>
    <p>
      Saloons permet aux utilisateurs d’interagir entre eux dans le cadre des fonctionnalités
      proposées par l’application.
    </p>
    <p>Les conversations et messages peuvent être temporaires et expirer après une durée déterminée.</p>
    <p>
      L’utilisateur est seul responsable des messages, contenus et informations qu’il communique
      via l’application.
    </p>
  </section>

  <section class="legal-section">
    <h3>6. Comportements interdits</h3>
    <p>L’utilisateur s’engage à utiliser Saloons de manière respectueuse et conforme à la loi.</p>
    <p>Sont notamment interdits :</p>
    <ul>
      <li>les propos insultants, discriminatoires, menaçants, violents ou harcelants ;</li>
      <li>l’usurpation d’identité ;</li>
      <li>la diffusion de contenus illicites, choquants ou portant atteinte aux droits d’autrui ;</li>
      <li>
        l’utilisation de l’application à des fins frauduleuses, commerciales non autorisées ou
        malveillantes ;
      </li>
      <li>
        toute tentative de contournement des règles de géolocalisation, de sécurité ou de
        fonctionnement de l’application.
      </li>
    </ul>
  </section>

  <section class="legal-section">
    <h3>7. Signalement et modération</h3>
    <p>
      L’utilisateur peut signaler un comportement ou un contenu inapproprié depuis l’application
      ou par email à l’adresse suivante :
    </p>
    <p class="legal-contact">support@saloons.fr</p>
    <p>
      Saloons se réserve le droit de prendre toute mesure utile en cas de non-respect des présentes
      CGU, notamment la suppression d’un contenu, la suspension temporaire d’un compte ou la
      suppression définitive d’un compte.
    </p>
  </section>

  <section class="legal-section">
    <h3>8. Services premium</h3>
    <p>Saloons peut proposer des fonctionnalités payantes ou premium.</p>
    <p>
      Les tarifs, conditions et fonctionnalités incluses sont présentés à l’utilisateur avant tout
      achat.
    </p>
    <p>
      Lorsque les achats sont réalisés via l’App Store ou Google Play, ils sont soumis aux
      conditions propres à ces plateformes.
    </p>
  </section>

  <section class="legal-section">
    <h3>9. Responsabilité</h3>
    <p>
      Saloons est une application d’interaction sociale. L’éditeur ne garantit pas la sincérité,
      l’exactitude ou la fiabilité des informations communiquées par les utilisateurs.
    </p>
    <p>
      L’utilisateur reste seul responsable de ses échanges, de ses rencontres et de l’utilisation
      qu’il fait de l’application.
    </p>
    <p>
      Saloons ne saurait être tenu responsable des comportements des utilisateurs, des litiges
      entre utilisateurs, d’une mauvaise utilisation de l’application ou d’une interruption
      temporaire du service.
    </p>
  </section>

  <section class="legal-section">
    <h3>10. Suppression du compte</h3>
    <p>
      L’utilisateur peut demander ou effectuer la suppression de son compte depuis l’application
      lorsque cette fonctionnalité est disponible.
    </p>
    <p>
      La suppression du compte entraîne la suppression ou l’anonymisation des données associées,
      sauf lorsque leur conservation est nécessaire pour respecter une obligation légale, traiter
      un signalement ou prévenir les abus.
    </p>
  </section>

  <section class="legal-section">
    <h3>11. Droit applicable</h3>
    <p>Les présentes CGU sont régies par le droit français.</p>
    <p>En cas de difficulté, l’utilisateur est invité à contacter Saloons à l’adresse suivante :</p>
    <p class="legal-contact">support@saloons.fr</p>
    <p>À défaut de résolution amiable, le litige pourra être porté devant les juridictions compétentes.</p>
  </section>
`;

export const PRIVACY_POLICY_TEXT = `
  <h2>Politique de confidentialité</h2>
  <p class="legal-updated">Dernière mise à jour : 26/04/2026</p>

  <section class="legal-section">
    <h3>1. Introduction</h3>
    <p>
      La présente Politique de confidentialité explique comment Saloons collecte, utilise et
      protège les données personnelles des utilisateurs.
    </p>
    <p>Saloons est éditée par :</p>
    <div class="legal-lines">
      <p>Mathieu Chauveau, entrepreneur individuel, exerçant sous le nom commercial Digital Saloons</p>
      <p>SIRET : 850 193 756 00028</p>
      <p>Adresse : 64 rue des Remparts, 33000 Bordeaux</p>
      <p>Email : support@saloons.fr</p>
    </div>
  </section>

  <section class="legal-section">
    <h3>2. Données collectées</h3>
    <p>
      Dans le cadre de l’utilisation de Saloons, l’application peut collecter les données
      suivantes :
    </p>
    <ul>
      <li>données d’identification : nom, prénom, pseudonyme, adresse email, identifiant utilisateur ;</li>
      <li>données de profil : photo, description, âge ou date de naissance, préférences renseignées ;</li>
      <li>
        données de localisation : position approximative ou précise, lorsque nécessaire au
        fonctionnement des saloons ;
      </li>
      <li>données d’interaction : saloons rejoints, clins d’œil, matchs, signalements, blocages ;</li>
      <li>messages échangés dans les conversations temporaires ;</li>
      <li>données techniques : adresse IP, type d’appareil, système d’exploitation, logs, erreurs techniques ;</li>
      <li>
        données liées aux achats premium, lorsque l’utilisateur utilise une fonctionnalité payante.
      </li>
    </ul>
  </section>

  <section class="legal-section">
    <h3>3. Utilisation des données</h3>
    <p>Les données collectées sont utilisées pour :</p>
    <ul>
      <li>créer et gérer le compte utilisateur ;</li>
      <li>permettre l’accès aux saloons ;</li>
      <li>vérifier la proximité géographique avec certains lieux ;</li>
      <li>afficher les lieux disponibles autour de l’utilisateur ;</li>
      <li>permettre les interactions entre utilisateurs ;</li>
      <li>faire fonctionner la messagerie temporaire ;</li>
      <li>gérer les signalements et la modération ;</li>
      <li>assurer la sécurité de l’application ;</li>
      <li>améliorer et corriger le service ;</li>
      <li>gérer les achats ou fonctionnalités premium ;</li>
      <li>répondre aux demandes des utilisateurs.</li>
    </ul>
  </section>

  <section class="legal-section">
    <h3>4. Géolocalisation</h3>
    <p>
      La géolocalisation est utilisée pour permettre le fonctionnement principal de Saloons,
      notamment l’accès aux saloons situés à proximité de l’utilisateur.
    </p>
    <p>
      L’utilisateur peut refuser ou désactiver l’accès à sa localisation depuis les réglages de son
      téléphone. Dans ce cas, certaines fonctionnalités de l’application peuvent être limitées ou
      indisponibles.
    </p>
    <p>
      Saloons ne collecte pas la localisation de l’utilisateur plus que nécessaire au fonctionnement
      du service.
    </p>
  </section>

  <section class="legal-section">
    <h3>5. Messagerie temporaire</h3>
    <p>Les messages échangés dans l’application peuvent être temporaires.</p>
    <p>
      Ils peuvent être conservés pendant une durée limitée afin d’assurer le fonctionnement de la
      conversation, la sécurité du service, le traitement des signalements ou la prévention des abus.
    </p>
    <p>
      À l’expiration d’une conversation, les messages peuvent être supprimés ou anonymisés, sauf
      nécessité liée à un signalement ou à une obligation légale.
    </p>
  </section>

  <section class="legal-section">
    <h3>6. Notifications</h3>
    <p>
      Saloons peut envoyer des notifications liées au fonctionnement de l’application, par exemple
      en cas d’interaction, de match, de message, d’expiration de session ou d’information
      importante liée au compte.
    </p>
    <p>
      L’utilisateur peut gérer ses autorisations de notifications depuis les paramètres de son
      téléphone.
    </p>
  </section>

  <section class="legal-section">
    <h3>7. Services tiers</h3>
    <p>Saloons peut utiliser des services tiers nécessaires au fonctionnement de l’application, notamment :</p>
    <ul>
      <li>OVH pour l’hébergement ;</li>
      <li>
        Firebase ou services équivalents pour l’authentification, les notifications ou certaines
        fonctionnalités techniques ;
      </li>
      <li>
        Apple et Google pour la distribution de l’application, l’authentification ou les achats
        intégrés ;
      </li>
      <li>Brevo ou service équivalent pour l’envoi d’emails.</li>
    </ul>
    <p>
      Ces services peuvent traiter certaines données conformément à leurs propres politiques de
      confidentialité ou aux instructions de Saloons.
    </p>
  </section>

  <section class="legal-section">
    <h3>8. Durée de conservation</h3>
    <p>
      Les données sont conservées pendant une durée proportionnée aux finalités pour lesquelles
      elles sont collectées.
    </p>
    <p>Les données de compte sont conservées tant que le compte utilisateur est actif.</p>
    <p>
      Les messages temporaires et données de session sont conservés pendant une durée limitée
      nécessaire au fonctionnement du service, puis supprimés ou anonymisés, sauf en cas de
      signalement, de litige ou d’obligation légale.
    </p>
    <p>
      Certaines données techniques peuvent être conservées temporairement pour assurer la sécurité,
      corriger les erreurs et prévenir les abus.
    </p>
  </section>

  <section class="legal-section">
    <h3>9. Sécurité</h3>
    <p>
      Saloons met en œuvre des mesures techniques et organisationnelles destinées à protéger les
      données personnelles contre l’accès non autorisé, la perte, l’altération ou la divulgation.
    </p>
    <p>Toutefois, aucun système informatique ne peut garantir une sécurité absolue.</p>
  </section>

  <section class="legal-section">
    <h3>10. Droits des utilisateurs</h3>
    <p>
      Conformément au RGPD, l’utilisateur dispose d’un droit d’accès, de rectification,
      d’effacement, d’opposition, de limitation du traitement et, lorsque cela s’applique, d’un
      droit à la portabilité de ses données.
    </p>
    <p>
      Pour exercer ses droits ou demander la suppression de son compte, l’utilisateur peut utiliser
      la fonctionnalité prévue dans l’application ou contacter Saloons à l’adresse suivante :
    </p>
    <p class="legal-contact">support@saloons.fr</p>
    <p>L’utilisateur peut également introduire une réclamation auprès de la CNIL.</p>
  </section>

  <section class="legal-section">
    <h3>11. Modification de la politique</h3>
    <p>
      Saloons peut modifier la présente Politique de confidentialité afin de tenir compte de
      l’évolution de l’application, de ses fonctionnalités ou de la réglementation applicable.
    </p>
    <p>
      En cas de modification importante, l’utilisateur pourra être informé par tout moyen approprié.
    </p>
  </section>
`;

export const LEGAL_NOTICES_TEXT = `
  <h2>Mentions légales</h2>

  <section class="legal-section">
    <h3>1. Éditeur de l’application</h3>
    <p>L’application Saloons est éditée par :</p>
    <div class="legal-lines">
      <p>Mathieu Chauveau, entrepreneur individuel, exerçant sous le nom commercial Digital Saloons</p>
      <p>SIRET : 850 193 756 00028</p>
      <p>Adresse : 64 rue des Remparts, 33000 Bordeaux</p>
      <p>Email : support@saloons.fr</p>
    </div>
    <p>Directeur de la publication : Mathieu Chauveau</p>
    <p>TVA non applicable, article 293 B du Code général des impôts.</p>
  </section>

  <section class="legal-section">
    <h3>2. Hébergement</h3>
    <p>L’application et les services associés sont hébergés par :</p>
    <div class="legal-lines">
      <p>OVH SAS</p>
      <p>SAS au capital de 50 000 000 €</p>
      <p>RCS Lille Métropole : 424 761 419 00045</p>
      <p>N° TVA : FR 22 424 761 419</p>
      <p>2 rue Kellermann</p>
      <p>59100 Roubaix</p>
      <p>France</p>
      <p>Site internet : www.ovhcloud.com</p>
    </div>
  </section>

  <section class="legal-section">
    <h3>3. Propriété intellectuelle</h3>
    <p>
      L’ensemble de l’application Saloons, incluant notamment son nom, son logo, ses interfaces,
      ses textes, ses visuels, ses fonctionnalités, sa structure, ses bases de données et ses
      éléments logiciels, est protégé par le droit de la propriété intellectuelle.
    </p>
    <p>
      Toute reproduction, représentation, modification, diffusion ou exploitation totale ou
      partielle de ces éléments, sans autorisation préalable écrite de l’éditeur, est interdite.
    </p>
  </section>

  <section class="legal-section">
    <h3>4. Absence d’affiliation</h3>
    <p>
      Sauf mention contraire dans l’application, Saloons n’est pas affiliée aux lieux,
      établissements, événements ou marques référencés.
    </p>
  </section>

  <section class="legal-section">
    <h3>5. Données personnelles</h3>
    <p>
      Le traitement des données personnelles des utilisateurs est régi par la Politique de
      confidentialité de Saloons, conformément au Règlement général sur la protection des données,
      dit RGPD.
    </p>
    <p>
      Pour toute demande relative aux données personnelles, l’utilisateur peut contacter Saloons à
      l’adresse suivante :
    </p>
    <p class="legal-contact">support@saloons.fr</p>
  </section>

  <section class="legal-section">
    <h3>6. Contact</h3>
    <p>
      Pour toute question relative à l’application, à son fonctionnement, aux présentes mentions
      légales ou à un signalement, l’utilisateur peut contacter Saloons à l’adresse suivante :
    </p>
    <p class="legal-contact">support@saloons.fr</p>
  </section>
`;
